function handleBannerAppear(banner) {
  document.documentElement.classList.add(
    'ultimadesk-cookie-banner-open'
  );

  const removalObserver = new MutationObserver(() => {
    const bannerRemoved = !document.body.contains(banner);
    const bannerHidden =
      banner.hidden ||
      banner.getAttribute('aria-hidden') === 'true' ||
      getComputedStyle(banner).display === 'none';

    if (bannerRemoved || bannerHidden) {
      document.documentElement.classList.remove(
        'ultimadesk-cookie-banner-open'
      );

      removalObserver.disconnect();
    }
  });

  removalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'class',
      'style',
      'hidden',
      'aria-hidden',
    ],
  });
}

function initCookieBannerObserver() {
  const existingBanner = document.querySelector(
    '#shopify-pc__banner'
  );

  if (existingBanner) {
    handleBannerAppear(existingBanner);
    return;
  }

  const appearObserver = new MutationObserver(() => {
    const banner = document.querySelector(
      '#shopify-pc__banner'
    );

    if (banner) {
      handleBannerAppear(banner);
      appearObserver.disconnect();
    }
  });

  appearObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    appearObserver.disconnect();
  }, 10000);
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initCookieBannerObserver,
    { once: true }
  );
} else {
  initCookieBannerObserver();
}